import React from "react";
import style from "./index.module.scss";

interface QuestionnaireTopicsButtonsProps {
    topicCount: string;
    totalScore: string;
}

export default function QuestionnaireTopicsButtons({
    topicCount,
    totalScore
}: QuestionnaireTopicsButtonsProps) {
    return (
        <div className={style.root}>
            <div className={style.count}>
                共 {topicCount} 题， {totalScore} 分
            </div>
        </div>
    );
}
